import Model from '@/models/Model.js';

export default class ModelPermission extends Model {
    static entity = 'model_has_permissions';

    static primaryKey = ['permission_id', 'model_id'];

    static fields() {
        return {
            permission_id: this.attr(null),
            model_type: this.attr(null),
            model_id: this.attr(null),
        };
    }
}
